function SpinnerTable({ colSpan }) {
  return (
    <>
      <tr>
        <td colSpan={colSpan ?? 1} className="text-center align-middle">
          <div className="d-flex justify-content-center align-items-center gap-2">
            <div className="spinner-border spinner-border-sm text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <span>Loading data...</span>
          </div>
        </td>
      </tr>
    </>
  );
}
export default SpinnerTable;
